import { IImpersonationStartResponse } from '@torim-app/types';
import { platformUrlBuilder, platformFetch } from './utils';

export class ImpersonationApi {
  static async impersonate(bid: string): Promise<IImpersonationStartResponse> {
    const url = platformUrlBuilder({}, `impersonate/${bid}`);
    const response = await platformFetch(url, { method: 'POST' });
    if (!response.ok) throw 'Failed to start impersonation';
    return response.json();
  }
}

/**
 * Base URL of the business-facing dashboard app that impersonation lands in.
 * Uses VITE_DASHBOARD_URL when configured (required in prod), and falls back
 * to the local dev dashboard (port 3000) when running on localhost.
 */
export const dashboardBaseUrl = (): string => {
  const configured = import.meta.env.VITE_DASHBOARD_URL as string | undefined;
  if (configured) return configured.replace(/\/$/, '');
  if (typeof location !== 'undefined' && location.hostname === 'localhost') {
    return 'http://localhost:3000';
  }
  return typeof location !== 'undefined' ? location.origin : '';
};

/**
 * Public booking site of a business (`/business/{bid}`), on the website app.
 * Falls back to production so the link is still useful when the env var is unset.
 */
export const businessSiteUrl = (bid: string): string => {
  const domain =
    (import.meta.env.VITE_BUSINESS_WEBSITE_DOMAIN as string | undefined) || 'https://time-it.co.il';
  return `${domain.replace(/\/$/, '')}/business/${bid}`;
};
